import { render, staticRenderFns } from "./NftWallet.vue?vue&type=template&id=5fb9a326&"
import script from "./NftWallet.vue?vue&type=script&lang=js&"
export * from "./NftWallet.vue?vue&type=script&lang=js&"
import style0 from "./NftWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports